import React from 'react';
import { createGlobalStyle, ThemeProvider, styled } from 'styled-components';
import LotteryDashboard from './components/LotteryDashboard';
import { theme } from './styles/theme';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    background-color: ${theme.colors.background};
    color: ${theme.colors.text};
    font-family: ${theme.fonts.primary};
    line-height: 1.5;
    overflow-x: hidden;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
  width: 6px;
  }

  ::-webkit-scrollbar-track {
  background: transparent;
  }

  ::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.15);
  border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
  background: rgba(255,255,255,0.25);
  }
`;

const AppWrapper = styled.div`
  min-height: 100vh;
  background-color: #000; // Solid black background
  display: flex;
  flex-direction: column;
`;

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <AppWrapper>
        <LotteryDashboard />
      </AppWrapper>
    </ThemeProvider>
  );
};

export default App;
